/* tslint:disable */
/* eslint-disable */
/**
 * Mild Blue s.r.o. - Online Connect
 * Application allowing people to ask for admition in IKEM.
 *
 * The version of the OpenAPI document: development
 * Contact: support@mild.blue
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { IdResponse } from '../model';
// @ts-ignore
import { ReceiptOrderDtoIn } from '../model';
// @ts-ignore
import { RegistrationDtoIn } from '../model';
/**
 * SubmissionApi - axios parameter creator
 * @export
 */
export const SubmissionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Save data from patient or doctor registration form.
         * @param {RegistrationDtoIn} [registrationDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubmissionsDoctorPost: async (registrationDtoIn?: RegistrationDtoIn, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/submissions/doctor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication sessionAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registrationDtoIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save data from patient or doctor registration form.
         * @param {RegistrationDtoIn} [registrationDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubmissionsPatientPost: async (registrationDtoIn?: RegistrationDtoIn, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/submissions/patient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication sessionAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registrationDtoIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save data from receipt order form.
         * @param {ReceiptOrderDtoIn} [receiptOrderDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubmissionsReceiptPost: async (receiptOrderDtoIn?: ReceiptOrderDtoIn, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/submissions/receipt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication sessionAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(receiptOrderDtoIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubmissionApi - functional programming interface
 * @export
 */
export const SubmissionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubmissionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Save data from patient or doctor registration form.
         * @param {RegistrationDtoIn} [registrationDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubmissionsDoctorPost(registrationDtoIn?: RegistrationDtoIn, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubmissionsDoctorPost(registrationDtoIn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save data from patient or doctor registration form.
         * @param {RegistrationDtoIn} [registrationDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubmissionsPatientPost(registrationDtoIn?: RegistrationDtoIn, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubmissionsPatientPost(registrationDtoIn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save data from receipt order form.
         * @param {ReceiptOrderDtoIn} [receiptOrderDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubmissionsReceiptPost(receiptOrderDtoIn?: ReceiptOrderDtoIn, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubmissionsReceiptPost(receiptOrderDtoIn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SubmissionApi - factory interface
 * @export
 */
export const SubmissionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubmissionApiFp(configuration)
    return {
        /**
         * 
         * @summary Save data from patient or doctor registration form.
         * @param {RegistrationDtoIn} [registrationDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubmissionsDoctorPost(registrationDtoIn?: RegistrationDtoIn, options?: any): AxiosPromise<IdResponse> {
            return localVarFp.apiSubmissionsDoctorPost(registrationDtoIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save data from patient or doctor registration form.
         * @param {RegistrationDtoIn} [registrationDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubmissionsPatientPost(registrationDtoIn?: RegistrationDtoIn, options?: any): AxiosPromise<IdResponse> {
            return localVarFp.apiSubmissionsPatientPost(registrationDtoIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save data from receipt order form.
         * @param {ReceiptOrderDtoIn} [receiptOrderDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubmissionsReceiptPost(receiptOrderDtoIn?: ReceiptOrderDtoIn, options?: any): AxiosPromise<IdResponse> {
            return localVarFp.apiSubmissionsReceiptPost(receiptOrderDtoIn, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubmissionApi - object-oriented interface
 * @export
 * @class SubmissionApi
 * @extends {BaseAPI}
 */
export class SubmissionApi extends BaseAPI {
    /**
     * 
     * @summary Save data from patient or doctor registration form.
     * @param {RegistrationDtoIn} [registrationDtoIn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public apiSubmissionsDoctorPost(registrationDtoIn?: RegistrationDtoIn, options?: any) {
        return SubmissionApiFp(this.configuration).apiSubmissionsDoctorPost(registrationDtoIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save data from patient or doctor registration form.
     * @param {RegistrationDtoIn} [registrationDtoIn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public apiSubmissionsPatientPost(registrationDtoIn?: RegistrationDtoIn, options?: any) {
        return SubmissionApiFp(this.configuration).apiSubmissionsPatientPost(registrationDtoIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save data from receipt order form.
     * @param {ReceiptOrderDtoIn} [receiptOrderDtoIn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionApi
     */
    public apiSubmissionsReceiptPost(receiptOrderDtoIn?: ReceiptOrderDtoIn, options?: any) {
        return SubmissionApiFp(this.configuration).apiSubmissionsReceiptPost(receiptOrderDtoIn, options).then((request) => request(this.axios, this.basePath));
    }
}
